import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCirclePlus = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11.156 15.094v-2.25h-2.25A.84.84 0 0 1 8.062 12c0-.468.377-.844.844-.844h2.25v-2.25c0-.467.376-.844.844-.844s.844.377.844.844v2.25h2.25c.467 0 .844.376.844.844a.84.84 0 0 1-.844.844h-2.25v2.25a.84.84 0 0 1-.844.844.84.84 0 0 1-.844-.844M21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9m-9-7.312A7.31 7.31 0 0 0 4.688 12 7.31 7.31 0 0 0 12 19.313 7.31 7.31 0 0 0 19.313 12 7.31 7.31 0 0 0 12 4.688"
    }));
export default SvgCirclePlus;
